export default __webpack_public_path__ + "static/char-s-sp03-en-44020b205bb918bba703f7375be11cd7.png";